import { Container, Typography, Button, Stack, Backdrop, CircularProgress } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import React, { useEffect, useState } from 'react';
import Gallery from 'react-photo-gallery';
import * as arrayMove from 'array-move';
import Page from '../components/Page';
import Photo from '../components/Photo';
import { getWorks, moveWork } from '../utils/requests/workRequest';

const SortablePhoto = SortableElement((item) => <Photo {...item} />);
const SortableGallery = SortableContainer(({ items }) => {
  const [photos, setPhotos] = useState(items);

  useEffect(() => {
    setPhotos(items);
  }, [items]);

  const onDelete = () => {};

  return (
    <>
      <Gallery
        direction="column"
        columns={(width) => (width > 500 ? 3 : 1)}
        photos={photos.map((item, index) =>
          Object({
            id: item.id,
            onDelete: () => onDelete(index),
            src: item.gallery.url,
            type: item.category.id,
            width: item.gallery.size.width,
            height: item.gallery.size.height
          })
        )}
        renderImage={(props) => <SortablePhoto {...props} />}
      />
    </>
  );
});

export default function Projects() {
  const [items, setItems] = useState([]);
  const navigate = useNavigate();
  /**
   * @type {"3d" | "videos" | "photos"}
   */
  const initPanel = 'photos';
  const [panel, setPanel] = useState(initPanel);
  const [isLoading, setIsLoading] = React.useState(false);

  useEffect(updateList, [panel]);

  const onSortEnd = ({ oldIndex, newIndex }) => {
    const newItems = arrayMove.arrayMoveImmutable(items, oldIndex, newIndex);
    setItems(newItems);
    moveWork(newItems);
  };

  function updateList() {
    setIsLoading(true);
    setItems([]);
    let id = 0;
    if (panel === '3d') id = 3;
    else if (panel === 'photos') id = 1;
    else if (panel === 'videos') id = 2;

    getWorks(id)
      .then((works) => {
        setItems(works);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  function addProjectPage() {
    navigate('./add');
  }

  return (
    <Page>
      <Container>
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={isLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        <Stack spacing={2}>
          <Stack direction="row" justifyContent="flex-start" alignItems="flex-start" spacing={2}>
            <Typography variant="h4" sx={{ mb: 5 }}>
              Projects
            </Typography>
            <Button variant="text" onClick={() => addProjectPage()}>
              Add new photo project
            </Button>
            <Button variant="text" onClick={() => navigate('./add/video')}>
              Add new video project
            </Button>
            <Button variant="text" onClick={() => navigate('./add/3d')}>
              Add new 3D project
            </Button>
          </Stack>
          <Stack direction="row" spacing={2}>
            <Button
              variant={panel === 'photos' ? 'contained' : 'text'}
              onClick={() => setPanel('photos')}
            >
              Photos
            </Button>
            <Button
              variant={panel === 'videos' ? 'contained' : 'text'}
              onClick={() => setPanel('videos')}
            >
              Videos
            </Button>
            <Button variant={panel === '3d' ? 'contained' : 'text'} onClick={() => setPanel('3d')}>
              3D Photos
            </Button>
          </Stack>
          {items && items.length ? (
            <SortableGallery items={items} onSortEnd={onSortEnd} axis="xy" />
          ) : (
            <></>
          )}
        </Stack>
      </Container>
    </Page>
  );
}
